import React, {useState, useEffect} from 'react';
import styles from './supplier.module.css';
import { axiosAuthFetch, axiosAuthFetchDelete } from '../../../helpers/apiActions/authFetch';
import { API_BASE_URL } from '../../../constants';
import defaultImage from '../../../images/Logo.png'
import { EditSupplierForm, AddSupplierForm } from '../editAndAddSupplier';
import Modal from 'react-bootstrap/Modal';
import Loader from '../../loader';

export default function HandleSuppliersForm() {
    const [suppliers, setSuppliers] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);
    const [showAddModal, setShowAddModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [selectedSupplier, setSelectedSupplier] = useState(null);

    useEffect(() => {
        const getSuppliers = async () => {
            setIsLoading(true);
            setIsError(false);

            try {
                const response = await axiosAuthFetch(`${API_BASE_URL}/suppliers?populate=*&pagination[pageSize]=50`);
                console.log(response);

                const sortedSuppliers = response.data.sort((a,b) =>
                a.attributes.name.localeCompare(b.attributes.name)
                );

                setSuppliers(sortedSuppliers);
            } catch (error) {
                console.error(error);
                setIsError(true);
            } finally {
                setIsLoading(false);
            }
        };

        getSuppliers();
    }, []);

    const handleDeleteSupplier = async (id) => {
        try {
            await axiosAuthFetchDelete(`${API_BASE_URL}/suppliers/${id}`);
            setSuppliers(suppliers.filter(supplier => supplier.id !== id));
        } catch (error) {
            console.error(error);
        }
    };

    if (isLoading) {
        return <div><Loader /></div>;
    }

    if (isError) {
        return <div>Error loading suppliers. Please try again later.</div>;
    }

    return (
        <div className={styles.container1}>
            <div className={styles.header}>
                <h1>Leverandører</h1>
                <div className={styles.addButton} onClick={() => setShowAddModal(true)}>Legg til leverandør</div>
            </div>
            <div className={styles.cardsParent}>
                {suppliers.map(supplier => {
                    const logoUrl = supplier.attributes.logo?.data?.attributes?.url || defaultImage;
                    return(
                        <div key={supplier.id} className={styles.card}>
                            <div className={styles.supplierImage} style={{ backgroundImage: `url(${logoUrl})` }}></div>
                            <div className={styles.supplierName}>{supplier.attributes.name}</div>
                            <div className={styles.buttonsContainer}>
                                <div className={styles.editButton} onClick={() => {setSelectedSupplier(supplier); setShowEditModal(true); }}>Rediger</div>
                                <div className={styles.deleteButton} onClick={() => handleDeleteSupplier(supplier.id)}>Slett</div>
                            </div>
                        </div>
                    );
                    })}
            </div>
            <Modal show={showAddModal} onHide={() => setShowAddModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Legg til leverandør</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <AddSupplierForm />
                </Modal.Body>
                <Modal.Footer>
                    <div className={styles.smalKnapp}>
                        <div className={styles.deleteButton}  onClick={() => setShowAddModal(false)}>Lukk</div>
                    </div>
                </Modal.Footer>
            </Modal>

            <Modal show={showEditModal} onHide={() => setShowEditModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Rediger leverandør</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {selectedSupplier && <EditSupplierForm supplier={selectedSupplier} />}
                </Modal.Body>
                <Modal.Footer>
                    <div className={styles.smalKnapp}>
                        <div className={styles.deleteButton} onClick={() => setShowEditModal(false)}>Lukk</div>
                    </div>
                </Modal.Footer>
            </Modal>
        </div>
    );
}